import { Controller } from '@hotwired/stimulus'

// A light embed of the youtube player
// https://developers.google.com/youtube/iframe_api_reference
// A more optimized version of embedding youtube videos in pages w/ a thumbnail
export default class extends Controller {
    static values = { id: String }

    connect() {
        this.createThumbnail()
    }

    createThumbnail() {
        const videoId = this.idValue
        const div = document.createElement('div')
        div.setAttribute('data-id', videoId)

        const thumbNode = document.createElement('img')
        thumbNode.src = `https://retreaver.s3.amazonaws.com/video_thumbnails/${videoId}.png`
        div.appendChild(thumbNode)

        const playButton = document.createElement('div')
        playButton.setAttribute('class', 'play')
        div.appendChild(playButton)

        div.onclick = () => this.loadIframe(div)
        this.element.appendChild(div)
    }

    loadIframe(div) {
        const iframe = document.createElement('iframe')
        iframe.setAttribute(
            'src',
            `https://www.youtube.com/embed/${this.idValue}?modestbranding=1&rel=0&showinfo=0&controls=1&autoplay=0&fs=0&color=white`,
        )
        iframe.setAttribute('frameborder', '0')
        iframe.setAttribute('allowfullscreen', '1')
        iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
        )
        div.parentNode.replaceChild(iframe, div)
    }
}
